export enum InstitutionValue {
    NAME = "NAME",
    CITY = "CITY",
    COUNTRY = "COUNTRY"
}